import Param from './param';
import Util from './module/libs/util';
import effectManager from './module/effect';
import btn from './module/global/btn';
import gnavi from './module/global/gnavi';
import tab from './module/global/lineupTab';
import entranceManager from './page/entrance';
import topManager from './page/top';
import FeedingAmountManager from './page/feedingAmount';
import newpackageManager from './page/newpackage';
import lowlayerManager from './page/lowlayer';
import studyManager from './page/study';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';

const util = new Util();

export default class Manager {
    constructor() {

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        /* fps計測用 */
        //this.fps = new Stats();
        //this.fps.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
        //document.body.appendChild( this.fps.dom );

        /* fps低下対策 */
        this.fpsRate;

        /* class用 */
        this.param = new Param();
        this.effect;
        this.scroll;
        this.mouse = false;
        this.btn;

        this.page; /* ページごとに読み込むのもを入れる */
        this.gnavi; /* TOP特徴 */
        this.lowlayer; //下層ページ共通で読み込むもの
        //設定
        this.conf = {
          lowlayerExclude : ["top","philosophy"] // lowlayerを読み込まないページ
        };



        /* ステータス */
        this.status = {
            loaded : false,
            loadedAddClass : false,
            paceDone : false, // ローダーライブラリ pace用
            pageID : "",
            prevPageID:"",
            execution : "",
            transFlg : false, //画面遷移監視用のフラグ
            touch : {
                nowInc : 0,
                inc    : 0
            },
            deviceOrientation:"",
            entrance:(location.search=='?entrance')? true:false,
            hash:(location.hash)? location.hash:false,
        }

        // タブレット判定
        const _ua = navigator.userAgent
        const isAndroid = /Android/i.test(_ua)
        const isIpad = /iPad/.test(_ua) || (/Macintosh/.test(_ua) && 'ontouchend' in document);
        this.isTablet = isIpad || (isAndroid && !_ua.match(/Android.+Mobile/));
        if (this.isTablet) {
            document.querySelector("html").classList.add('tablet')
        };

    }
    init(execution){ /* 初期化 */

        this.status.execution = execution;

        if(this.status.execution=="landing"){
            // 非同期遷移で書き換えないもの。初回読み込みのみ実行
            this.status.pageID = document.getElementsByTagName('body')[0].getAttribute("id");
            this.status.prevPageID = this.status.pageID;
            this.loadCommon();
            TweenMax.set(document.getElementById("l-root"),{opacity:1});
        }

        this.loadPage();

    }
    loadCommon(){ /* 共通で読み込むもの */

        this.effect = new effectManager();
        this.scroll = new smoothScrollManager(this.effect,this.status.pageID,this.isTablet);
        this.mouse = Useragnt.pc ? new MouseManager(this.isTablet) : false;
        if(this.mouse){
            this.mouse.init();
        }
        this.gnavi = new gnavi();
        this.gnavi.init(this.status.pageID);
        if(document.querySelectorAll(".js__tab-select")[0]) {
            this.tab = new tab(this.scroll,this.param,this.status.hash);
        }

        this.effect.show(document.querySelectorAll(".js__sp-ui-show"),"set");
        setTimeout(()=>{
            if(!this.status.entrance) {
                if (this.param.displayType == "pc") {
                    this.effect.show(document.querySelectorAll(".js__sp-ui-show"), "show");
                } else {
                    this.effect.show(document.querySelectorAll(".js__sp-ui-show:not(.js__gnavi-show)"), "show");
                }
            }
        },1e3);

        setTimeout(()=>{
            this.scroll.init(this.status.pageID);
            if(this.tab) this.tab.init();
            this.resize();
            if(this.status.execution==="landing") this.render();
        },1e2);
    }
    loadPage(){ /* ページごとに分岐するもの */

        if(this.status.pageID!=="top"&&this.status.pageID!=="philosophy"){
            this.status.loaded = true;
            document.body.classList.add("is-loaded");
            //domのローディング判定。wbglなどjs経由で読み込むものは別
        }

        if(Useragnt.pc||this.isTablet){
            this.btn = new btn();
            this.btn.init();
        }

        if(this.mouse) this.mouse.status.off = true;//マウスの位置を取得する機能を一旦オフ

        //ページごとに読み込むもの
        this.page = false;
        if(this.status.pageID=="top") {
            if(this.status.entrance){ //エントランス
                this.page = new entranceManager(this.effect);
            }else{ // 犬、猫TOP
                this.page = new topManager(this.effect,this.scroll,this.param,this.status.hash);
            }
            this.page.init(this.scroll,this.mouse);
            if(this.mouse) this.mouse.status.off = false;
        }else if(this.status.pageID=="feeding_amount") {
            this.feedingAmount = new FeedingAmountManager();
            this.feedingAmount.init();
        }else if(this.status.pageID=="newpackage") {
            this.newpackage = new newpackageManager(this.effect);
            this.newpackage.init();
        } else if(this.status.pageID=="study") {
            this.study = new studyManager(this.effect);
            this.study.init();
        }

        //下層ページのみ読み込むもの
        this.lowlayer = false;
        if (this.conf.lowlayerExclude.indexOf(this.status.pageID) == -1){
            this.lowlayer = new lowlayerManager(this.effect,this.mouse,this.param);
            this.lowlayer.init(this.status.execution,this.status.pageID);
            if(this.mouse) this.mouse.status.off = false;
        }

    }
    render(){

        if(!requestAnimationFrame){
            setTimeout(()=>this.render,1000/60);
        }else{
            requestAnimationFrame(this.render.bind(this));
        }

        this.fpsRate = util.updateTimeRatio();


        //this.fps.begin();

        if(!this.status.transFlg) this.scroll.move(this.fpsRate);
        if(this.mouse) this.mouse.move();


        if(this.page){
            if(this.mouse){
                this.page.render(this.scroll.inc,this.mouse);
            }else{
                this.page.render(this.scroll.inc);
            }
        }

        if(this.lowlayer){
            this.lowlayer.render(this.scroll.inc);
        }

        //this.fps.end();

    }
    resize(){

        this.param.displayType = ( window.innerWidth>this.param.breakpoint)?"pc":"sp";

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        // if(pageID==="top")toppage.resize();
        this.scroll.resize(this.w,this.h);
        if(this.page) this.page.resize(this.w,this.h,this.param.displayType);
        if(this.lowlayer) this.lowlayer.resize(this.param.displayType);
        if(this.gnavi) this.gnavi.resize(this.w,this.h,this.param.displayType);
        if(this.tab) this.tab.resize(this.param.displayType);
    }
    orientation(e){

        let angle = (screen && screen.orientation && screen.orientation.angle) || window.orientation || 0;

        let _roule = (Useragnt.mobile||this.isTablet)?angle % 180 !== 0:false;

        if(_roule) {
            if(this.status.deviceOrientation != "landscape") this.resize()
            this.status.deviceOrientation = "landscape";
        } else {
            if(this.status.deviceOrientation != "portrait") this.resize()
            this.status.deviceOrientation = "portrait";
        }

    }

    wheel(e){

        //フルスクリーン系のスペコンでスクロールイベントころすとき

        // let _delta = e.deltaY ? -(e.deltaY) : e.wheelDelta ? e.wheelDelta : -(e.detail);


        // switch (this.status.pageID) {
        //     case 'dummy':
        //         e.preventDefault();
        //         if (_delta < 0){
        //             if (_delta > -30&&Useragnt.mac||_delta > -30&&Useragnt.windows&&!Useragnt.firefox||_delta > -1&&Useragnt.windows&&Useragnt.firefox) return;
        //             this.page.update('next');
        //         }else if (_delta > 0){
        //             if (_delta < 30&&Useragnt.mac||_delta < 30&&Useragnt.windows&&!Useragnt.firefox||_delta < 1&&Useragnt.windows&&Useragnt.firefox) return;
        //             this.page.update('prev');
        //         }
        //         break;
        // }


    }
    touchmove(e){

        // e.preventDefault();

    }
    touchStart(e){
        // touchInc.x = e.touches[0].pageX;
        this.status.touch.inc = e.touches[0].pageY;

    }
    touchEnd(e){

        //フルスクリーン系のスペコンでタッチイベントころすとき

        // this.status.touch.nowInc = e.changedTouches[0].pageY;
        // switch (this.status.pageID) {
        //     case 'dummy':
        //         if(this.gnavi.status.mode=="open") return;
        //         if (this.status.touch.inc > this.status.touch.nowInc && this.status.touch.inc - this.status.touch.nowInc > 50) {
        //             this.page.update('next');
        //         } else if (this.status.touch.inc < this.status.touch.nowInc && this.status.touch.nowInc - this.status.touch.inc > 50) {
        //             this.page.update('prev');
        //         }
        //         break;
        // }

    }
    // 画面遷移用
    show(){

        if(this.lowlayer){
            this.lowlayer.show();
            setTimeout(()=>{
                this.status.transFlg = false;
            },3e2);
        }else{
            setTimeout(()=>{
                this.status.transFlg = false;
            },3e2);
        }

    }
    // 画面遷移用
    out(){


        this.status.transFlg = true;
        setTimeout(()=>{
            this.scroll.reset();
        },1e3);

        if(this.status.prevPageID!="top"){
            this.lowlayer.out();
        }

        this.status.prevPageID = this.status.pageID;

    }
}